export var GroupItemCategory;
(function (GroupItemCategory) {
    GroupItemCategory["before"] = "before";
    GroupItemCategory["after"] = "after";
    GroupItemCategory["help"] = "help";
    GroupItemCategory["input"] = "input";
})(GroupItemCategory || (GroupItemCategory = {}));
export var ValueChangeAction;
(function (ValueChangeAction) {
    ValueChangeAction["blur"] = "blur";
    ValueChangeAction["input"] = "input";
})(ValueChangeAction || (ValueChangeAction = {}));
